import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"book-simple, guide, info, faq"} maskId="square-filled-radius-0-stroke-1-IconBookSimple"><path fillRule="evenodd" clipRule="evenodd" d="M6.5 2C5.11929 2 4 3.11929 4 4.5V19.5C4 20.8807 5.11929 22 6.5 22H20V2H6.5ZM5 19.5C5 20.3284 5.67157 21 6.5 21H19V18H6.5C5.67157 18 5 18.6716 5 19.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBookSimple;
